export enum DualListBoxHeaderSize {
    standard = 'standard',
    smaller = 'smaller',
    none = 'none'
}
